// extracted by mini-css-extract-plugin
export var heading = "nutritional-information-module--heading--c4b5c";
export var hidden = "nutritional-information-module--hidden--e6826";
export var infoContainer = "nutritional-information-module--info-container--55874";
export var information = "nutritional-information-module--information--c60d0";
export var informationTitle = "nutritional-information-module--information-title--294db";
export var values = "nutritional-information-module--values--05f03";
export var valuesHeading = "nutritional-information-module--values-heading--603ba";